module.exports = __webpack_public_path__ + "img/sld_mfm_t1_b1_dark.3bda95f5.svg";